import React from "react";
import { useDiscovery } from "./DiscoveryContext";
import {
  XMarkIcon,
  LightBulbIcon,
  BoltIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";

const ContextualHint = ({ id, variant = "info", message, onDismiss }) => {
  const { preferences, markHintAsDismissed } = useDiscovery();

  if (!preferences || preferences.dismissedHints.includes(id)) {
    return null;
  }

  const handleDismiss = () => {
    markHintAsDismissed(id);
    if (onDismiss) onDismiss();
  };

  const variants = {
    info: {
      container:
        "bg-blue-50 dark:bg-blue-900/20 border-blue-200 dark:border-blue-800",
      icon: (
        <LightBulbIcon className="h-5 w-5 text-blue-600 dark:text-blue-400" />
      ),
      text: "text-blue-800 dark:text-blue-200",
      close: "text-blue-600 dark:text-blue-400 hover:text-blue-800",
    },
    success: {
      container:
        "bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800",
      icon: <BoltIcon className="h-5 w-5 text-green-600 dark:text-green-400" />,
      text: "text-green-800 dark:text-green-200",
      close: "text-green-600 dark:text-green-400 hover:text-green-800",
    },
    warning: {
      container:
        "bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800",
      icon: (
        <InformationCircleIcon className="h-5 w-5 text-yellow-600 dark:text-yellow-400" />
      ),
      text: "text-yellow-800 dark:text-yellow-200",
      close: "text-yellow-600 dark:text-yellow-400 hover:text-yellow-800",
    },
  };

  const style = variants[variant] || variants.info;

  return (
    <div
      className={`border rounded-xl p-4 mb-2 transition-all animate-in fade-in slide-in-from-top-4 duration-500 shadow-sm ${style.container}`}
    >

      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 flex-1">
          <div className="flex-shrink-0">{style.icon}</div>
          <div className={`text-sm font-medium ${style.text}`}>{message}</div>
        </div>
        <button
          onClick={handleDismiss}
          className={`flex-shrink-0 transition-colors p-1 rounded-full hover:bg-black/5 dark:hover:bg-white/5 ${style.close}`}
        >
          <XMarkIcon className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default ContextualHint;
